

































































































































































































































































import OrderBar from '../components/order_bar.vue'
import Template from '@/views/template.vue'
import {
  apiCommodityDeliveryCommodityStoreDetail,
  apiMerchantStoreCommodityGroupList,
  apiShoppingCartAdd,
  apiShoppingCartAddOrSub,
  apiShoppingCartList,
  apiShoppingCartRemove,
} from '@/api'
import { asRequiredDeep, keyBy, toArray, wait } from 'vtils'
import { computed, ref, watch } from '@vue/composition-api'
import {
  defineClassComponent,
  useActivated,
  useApiPlus,
  useHandler,
  useQuery,
} from '@/hooks'
import { instantDeliveryBus } from '../bus'
import { navigateTo } from '@/router'
import { pageBridge } from '@/components'
import { showSkuPicker } from '../utils'
import { Track } from '@/utils'

export default defineClassComponent(
  {
    components: {
      OrderBar,
      Template,
    },
  },
  ({ ctx }) =>
    class {
      constructor() {
        Track.useMark(() => ({
          page: '店铺首页',
        }))

        useActivated(() =>
          instantDeliveryBus.on('refreshCart', () => {
            this.apiData.refresh('cartData')
          }),
        )

        const offLoadingWatch = watch(
          () => this.loading.value,
          () => {
            if (!this.loading.value) {
              wait(0).then(() => {
                const pageHeaderEl: HTMLDivElement = document.querySelector(
                  '.__page_header__',
                ) as any
                const pageHeaderHeight =
                  pageHeaderEl.getBoundingClientRect().height
                const groupListEl: HTMLDivElement = ctx.$refs.groupList as any
                const groupElList = toArray(groupListEl.children)
                const groupTopList = groupElList.map(groupEl => {
                  return (
                    groupEl.getBoundingClientRect().top - pageHeaderHeight
                  )
                })
                this.groupTopList.value = groupTopList
              })
              offLoadingWatch()
            }
          },
          {
            immediate: true,
          },
        )

        useActivated(() =>
          pageBridge.on('scroll', ({ scrollTop }) => {
            let index = this.groupTopList.value.findIndex(
              groupTop => groupTop - 10 >= scrollTop,
            )
            index =
              index === -1
                ? this.groupTopList.value.length - 1
                : index === 0
                ? 0
                : index - 1
            this.categoryIndex.value = index
          }),
        )
      }

      loading = computed(() => this.apiData.loading)

      query = useQuery<{
        martId: string
      }>({
        martId: {
          alias: 'id',
        },
      })

      apiData = useApiPlus(
        {
          martData: () =>
            apiCommodityDeliveryCommodityStoreDetail({
              storeId: this.query.martId,
            }),
          categoryData: () =>
            apiMerchantStoreCommodityGroupList({
              storeId: this.query.martId,
            }).then(res => {
              // 排除无效的 SKU
              res.forEach(item => {
                item.commodityList.forEach(goods => {
                  goods.skuList = goods.skuList?.filter(
                    // @ts-ignore
                    sku => sku.skuStatus === 1,
                  )
                })
              })
              res = res
                .map(item => {
                  // 排除无 SKU 的商品
                  item.commodityList = item.commodityList.filter(
                    goods => !!goods.skuList?.length,
                  )
                  return item
                })
                // 排除无商品的分类
                .filter(item => !!item.commodityList.length)
              return res
            }),
          cartData: () =>
            apiShoppingCartList(
              {},
              {
                businessChannel: this.query.martId,
              },
            ).then(asRequiredDeep),
        },
        {
          refreshOnActivated: true,
        },
      )

      martData = computed(() => this.apiData.data.martData)

      categoryData = computed(() => this.apiData.data.categoryData)

      cartData = computed(() => this.apiData.data.cartData)

      cartMap = computed(() =>
        keyBy(this.cartData.value.validList, item => item.skuId),
      )

      isMartClosed = computed(() => this.martData.value.storeStatus !== 2)

      categoryIndex = ref(0)

      shareParams = computed(() => ({
        title: this.martData.value.storeName,
        desc: '',
        cover: this.martData.value.storeLogo,
      }))

      // [100, 200, 444, 600]
      groupTopList = ref<number[]>([])

      handleServiceClick = useHandler<
        '店铺详情' | '切换分类' | '商品' | '选规格' | '更新购物车数量'
      >({
        店铺详情: () => {
          navigateTo('InstantDeliveryMartDetail', {
            martId: this.query.martId,
          })
        },
        切换分类: (index: number) => {
          this.categoryIndex.value = index
          window.scrollTo({
            top: this.groupTopList.value[index],
            behavior: 'auto',
          })
        },
        商品: (goodsId: string) => {
          navigateTo('InstantDeliveryGoodsIndex', {
            goodsId,
          })
        },
        选规格: (goods: any) => {
          showSkuPicker({
            martId: this.query.martId,
            goods: goods,
          })
        },
        更新购物车数量: async (
          goodsId: string,
          skuId: string,
          delta: number,
        ) => {
          if (!this.cartMap.value[skuId]) {
            await apiShoppingCartAdd(
              {
                commodityId: goodsId,
                skuId: skuId,
                quantity: 1,
              },
              {
                businessChannel: this.query.martId,
              },
            )
          } else {
            const count = this.cartMap.value[skuId].quantity + delta
            if (count <= 0) {
              await apiShoppingCartRemove(
                {
                  idList: [this.cartMap.value[skuId].id],
                },
                {
                  businessChannel: this.query.martId,
                },
              )
            } else {
              await apiShoppingCartAddOrSub(
                {
                  id: this.cartMap.value[skuId].id,
                  quantity: count,
                },
                {
                  businessChannel: this.query.martId,
                },
              )
            }
          }
          instantDeliveryBus.emit('refreshCart')
        },
      })
    },
)
